import { FC } from 'react'
import { Nav } from '@/components/Layout'

export const Body: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <div className="z-0 flex min-h-0 flex-1">
      <Nav />
      <div className="min-h-0 flex-1 overflow-auto">
        <main className="relative z-0 min-h-0">{children}</main>
      </div>
    </div>
  )
}
